<template>
  <div v-loading="loading">
    <headerNotice routerName="订单详情"></headerNotice>
    <div class="btn-wrapper">
      <el-button type="primary" @click="back">返 回</el-button>
    </div>
    <!-- 订单进度条 -->
    <!-- <div class="orderStep" v-if="orderItems.orderCustomisationList.length>0">
      <el-steps :active="showsuccess()" align-center finish-status="success">
        <el-step title="提交订单" :description="steps[0]"></el-step>
        <el-step title="审核订单" :description="steps[1]"></el-step>
        <el-step title="定制订单" :description="steps[2]"></el-step>
        <el-step title="平台发货" :description="steps[3]"></el-step>
        <el-step title="确认收货" :description="steps[4]"></el-step>
        <el-step title="交易完成" :description="steps[4]"></el-step>
      </el-steps>
    </div>
    <div class="orderStep" v-if="orderItems.orderCustomisationList.length==0">
      <el-steps :active="showsuccess()" align-center finish-status="success">
        <el-step title="提交订单" :description="steps[0]"></el-step>
        <el-step title="审核订单" :description="steps[1]"></el-step>
        <el-step title="平台发货" :description="steps[2]"></el-step>
        <el-step title="确认收货" :description="steps[3]"></el-step>
        <el-step title="交易完成" :description="steps[3]"></el-step>
      </el-steps>
    </div> -->
    <!-- 订单信息 -->
    <div class="orderInfoBox">
      <!-- 订单状态 及操作 -->
      <div class="handle">
        <div class="orderStatus">
          <i class="el-icon-warning"></i>
          <span v-if="orderItems.status==1">当前订单状态：待付款</span>
          <span v-if="orderItems.status==3">当前订单状态：待审核</span>
          <span v-if="orderItems.status==4">当前订单状态：配货中</span>
          <span v-if="orderItems.status==5">当前订单状态：异常订单</span>
          <span v-if="orderItems.status==13">当前订单状态：退货中</span>
          <span v-if="orderItems.status==8">当前订单状态：待收货</span>
          <span v-if="orderItems.status==10">当前订单状态：已完成</span>
          <span v-if="orderItems.status==14">当前订单状态：已关闭</span>
                                   <span v-if="orderItems.status==17" style="color:#f63b3b;">退款成功</span>
                          <span v-if="orderItems.status==18" style="color:#f63b3b;">退款失败</span>
        </div>
        <div class="handleBox">
          <el-button v-if="orderItems.status==3" @click="setVerifyDialog=true">审核订单</el-button>
          <el-button v-if="orderItems.status==5" @click="changeToNormal(orderItems.orderID)">转正常</el-button>
          <el-button
            v-if="orderItems.status==3 || orderItems.status==1"
            @click="closeOrder(orderItems.orderID)"
          >关闭订单</el-button>
          <el-button v-if="orderItems.status==4" @click="markupException">标记异常</el-button>
          <el-button
            v-if="orderItems.status==8 || orderItems.status==10"
            @click="orderFollow(orderItems.orderID)"
          >订单跟踪</el-button>
          <el-button v-if="orderItems.status==14" @click="delOrder(orderItems.orderID)">删除订单</el-button>
          <el-button
            v-if="orderItems.status==8 || orderItems.status==10 || orderItems.status==14"
            @click="remarkOrder(orderItems.orderID)"
          >备注订单</el-button>
        </div>
      </div>
      <div class="infoBox">
        <!-- 基本信息 -->
        <div class="title">
          <i class="el-icon-info"></i>
          <span>基本信息</span>
        </div>
        <div class="baseInfoBox">
          <ul>
            <li>
              <h3>订单编号</h3>
              <div class="content">{{orderItems.orderCode}}</div>
            </li>
            <li>
              <h3>发货单流水号</h3>
              <div class="content">{{orderItems.expressCode}}</div>
            </li>
            <li>
              <h3>客户名称</h3>
              <div class="content">
                {{orderItems.customer}}
                <!-- &nbsp;&nbsp;
                                <span
                                    style="color:red;"
                >查看</span>-->
              </div>
            </li>
            <li>
              <h3>支付方式</h3>
              <div class="content">{{orderItems.payType==1?'微信':'余额'}}</div>
            </li>
            <li>
              <h3>订单类型</h3>
              <div class="content">{{orderItems.agent==0?'自主下单':'代客下单'}}</div>
            </li>
            <li>
              <h3>物流公司</h3>
              <div class="content">{{orderItems.logistics}}</div>
            </li>
            <li>
              <h3>物流单号</h3>
              <div class="content">{{orderItems.expressNo}}</div>
            </li>
            <li>
              <h3>发货仓库</h3>
              <div class="content">{{orderItems.wareHouse}}</div>
            </li>
            <!-- <li>
              <h3>订单可得积分</h3>
              <div class="content">{{orderItems.integral}}</div>
            </li> -->
            <!-- <li>
                            <h3>业务员提成</h3>
                            <div class="content">{{orderItems.commission}}</div>
            </li>-->
          </ul>
        </div>
        <!-- 发票信息 -->
        <div class="title">
          <i class="el-icon-info"></i>
          <span>发票信息</span>
        </div>
        <div class="invoiceBox">
          <ul v-if="orderItems.invoice">
            <li>
              <h3>发票类型</h3>
              <div class="content" v-if="orderItems.invoice.type==1">普通发票</div>
              <div class="content" v-else-if="orderItems.invoice.type==2">增值税发票</div>
              <div class="content" v-else>无发票</div>
            </li>
            <li v-if="orderItems.invoice.type">
              <h3>发票抬头</h3>
              <div class="content">{{orderItems.invoice.inviceName}}</div>
            </li>
            <li v-if="orderItems.invoice.type">
              <h3>发票内容</h3>
              <div class="content">{{orderItems.invoice.content}}</div>
            </li>
            <li v-if="orderItems.invoice.type">
              <h3>纳税人号</h3>
              <div class="content">{{orderItems.invoice.taxNo}}</div>
            </li>
            <li v-if="orderItems.invoice.type==2">
              <h3>地址</h3>
              <div class="content">{{orderItems.invoice.address}}</div>
            </li>
            <li v-if="orderItems.invoice.type==2">
              <h3>电话</h3>
              <div class="content">{{orderItems.invoice.phone}}</div>
            </li>
            <li v-if="orderItems.invoice.type==2">
              <h3>开户银行</h3>
              <div class="content">{{orderItems.invoice.bankName}}</div>
            </li>
            <li v-if="orderItems.invoice.type==2">
              <h3>开户账号</h3>
              <div class="content">{{orderItems.invoice.bankCode}}</div>
            </li>
          </ul>
          <div v-else class="content">不开具无发票</div>
        </div>
        <!-- 收货信息 -->
        <div class="title">
          <i class="el-icon-info"></i>
          <span>收货人信息</span>
        </div>
        <div class="receiptBox">
          <ul v-if="orderItems.orderAddress">
            <li>
              <h3>收货人</h3>
              <div class="content">{{orderItems.orderAddress.recipient}}</div>
            </li>
            <li>
              <h3>手机号码</h3>
              <div class="content">{{orderItems.orderAddress.phone}}</div>
            </li>
            <li>
              <h3>收货地址</h3>
              <div class="content">
                {{orderItems.orderAddress.provinceName+orderItems.orderAddress.cityName}}
                {{orderItems.orderAddress.areaName+orderItems.orderAddress.address}}
              </div>
            </li>
          </ul>
        </div>
        <!-- 商品信息 -->
        <div class="title">
          <i class="el-icon-info"></i>
          <span>商品信息</span>
        </div>
        <div class="goodsInfoBox">
          <el-table class="goodsTable" :data="orderItems.itemList" border style="width: 100%">
            <el-table-column prop="date" align="center" label="商品图片" width="120">
              <template slot-scope="scope">
                <img :src="baseUrl+scope.row.imgUrl" alt width="100" height="100" />
              </template>
            </el-table-column>
            <el-table-column prop="title" align="center" label="商品名称" width="180"></el-table-column>
            <el-table-column align="center" label="规格名称/规格编号">
              <template slot-scope="scope">
                <div class="specAndCode">
                  <span>规格：{{scope.row.propName}}</span>
                  <span>编号：{{scope.row.propCode}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="num" align="center" label="数量"></el-table-column>
            <el-table-column prop="price" align="center" label="单价"></el-table-column>
            <el-table-column prop="price" align="center" label="是否定制">
              <template slot-scope="scope">
                <span v-if="scope.row.isCustomized==1" style="color:#f63b3b;">是</span>
                <span v-if="scope.row.isCustomized==0" style="color:#f63b3b;">否</span>
              </template>
            </el-table-column>
            <el-table-column prop="total" align="center" label="小计"></el-table-column>
            <el-table-column prop="remark" align="center" label="备注"></el-table-column>
          </el-table>
          <div class="sum">共{{orderItems.count}}款{{orderItems.sum}}件商品</div>
        </div>
        <!-- 费用信息 -->
        <div class="title">
          <i class="el-icon-info"></i>
          <span>费用信息</span>
        </div>
        <div class="tipsBox">
          <ul>
            <li>
              <h3>订单总金额</h3>
              <div class="content red">￥{{orderItems.amount}}</div>
            </li>
            <li>
              <h3>运费</h3>
              <div class="content">{{orderItems.postage}}</div>
            </li>
            <li>
              <h3>活动优惠</h3>
              <div class="content">{{orderItems.amount-orderItems.disAmount}}</div>
            </li>
            <li>
              <h3>应付款金额</h3>
              <div class="content red">￥{{orderItems.disAmount + orderItems.postage}}</div>
            </li>
          </ul>
        </div>
        <!-- 定制信息 -->
        <div class="title" v-if="orderItems.orderCustomisationList.length>0">
          <i class="el-icon-info"></i>
          <span>定制信息</span>
        </div>
        <div v-for="item in orderItems.orderCustomisationList" v-bind:key="item">
          <div v-if="item.customizationType==1">
            定制类型：图案 定制图案名称：{{item.customizationName}}
            <br />定制图案：
            <img :src="baseUrl+item.customizationImageUrl" alt width="100" height="100" />
          </div>
          <div v-else>定制类型：语录 语录名称：{{item.customizationName}}</div>
        </div>
        <!-- 赠品信息 -->
        <div class="title">
          <i class="el-icon-info"></i>
          <span>赠品信息</span>
        </div>
        <div class="giftBox">
          <el-table class="goodsTable" :data="orderItems.freebieList" border style="width: 100%">
            <el-table-column prop="date" align="center" label="商品图片" width="120">
              <template slot-scope="scope">
                <img :src="baseUrl+scope.row.imgUrl" alt width="100" height="100" />
              </template>
            </el-table-column>
            <el-table-column prop="title" align="center" label="商品名称" width="180"></el-table-column>
            <el-table-column prop="address" align="center" label="规格名称/规格编号">
              <template slot-scope="scope">
                <div class="specAndCode">
                  <span>规格：{{scope.row.propName}}</span>
                  <span>编号：{{scope.row.propCode}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="num" align="center" label="数量"></el-table-column>
            <el-table-column prop="activeName" align="center" label="活动名称"></el-table-column>
            <el-table-column prop="activeItem" align="center" label="活动商品名称"></el-table-column>
          </el-table>
        </div>
        <!-- 佣金信息 -->
        <div class="title">
          <i class="el-icon-info"></i>
          <span>佣金信息</span>
        </div>
        <span class="shangerji">上二级：{{orderItems.twoDistributionUser}}</span>
        <span class="shangerji">佣金：{{orderItems.twoCommission}}</span>

        <br />
        <span class="shangerji">上一级：{{orderItems.oneDistributionUser}}</span>
        <span class="shangerji">佣金：{{orderItems.oneCommission}}</span>

        <br />
        <div style="margin-top:10px;">佣金总额：{{orderItems.sumCommission}}</div>
        <!-- 操作信息 -->
        <div class="title">
          <i class="el-icon-info"></i>
          <span>操作信息</span>
        </div>
        <div class="giftBox">
          <el-table class="goodsTable" :data="orderItems.orderLog" border style="width: 100%">
            <el-table-column prop="operator" align="center" label="操作者" width="180"></el-table-column>
            <el-table-column prop="createTime" align="center" label="操作时间" width="250"></el-table-column>
            <el-table-column prop="orderStatus" align="center" label="订单状态"></el-table-column>
            <el-table-column prop="payStatus" align="center" label="付款状态"></el-table-column>
            <el-table-column prop="expressStatus" align="center" label="发货状态"></el-table-column>
            <el-table-column prop="remark" align="center" label="备注"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 审核订单dialog框 -->
    <el-dialog title="批量审核订单" class="auditDialog" :visible.sync="setVerifyDialog" width="35%">
      <el-form :model="auditForm" class="signUp_Form" label-width="125px">
        <el-row>
          <el-col class="sale" :span="20">
            <el-form-item label="审核状态：" :rules="[{'required':true}]">
              <el-switch
                v-model="auditForm.audit"
                :active-value="1"
                :inactive-value="0"
                active-text="审核"
                inactive-text="待审核"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="sale" :span="20">
            <el-form-item label="备注：" :rules="[{'required':true}]">
              <el-input
                type="textarea"
                maxlength="100"
                placeholder="请输入备注，备注内容不能超过100个字"
                :autosize="{minRows: 6 }"
                clearable
                v-model="auditForm.remark"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="btnBox" style="text-align:center;">
          <el-button @click="cancelBtn">取消</el-button>
          <el-button @click="auditOrderConfirm" type="primary">确认</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!-- 批量通用标记dialog框 -->
    <el-dialog :title="commonDialogTitle" :visible.sync="commonRemarkDialog" width="30%">
      <el-form :model="commonDialogForm" class="signUp_Form" label-width="125px">
        <el-row>
          <el-col class="sale" :span="20">
            <el-form-item label="备注：" :rules="[{'required':true}]">
              <el-input
                type="textarea"
                maxlength="100"
                placeholder="请输入备注，备注内容不能超过100个字"
                :autosize="{minRows: 6 }"
                clearable
                v-model="commonDialogForm.remark"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="btnBox" style="text-align:center;">
          <el-button @click="cancelBtn">取消</el-button>
          <el-button @click="commonDialogConfirm" type="primary">确认</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  data() {
    return {
      baseUrl: this.$store.state.apiUrl,
      loading: true,
      orderCode: null,
      orderItems: {
        orderStatus: [],
        orderAddress: {},
        invoice: {},
        orderCustomisationList: []
      },
      steps: [], //进度条
      stepsstatus: [], //进度条状态
      setVerifyDialog: false,
      auditForm: {
        audit: 0,
        remark: ""
      }, //审核表单
      commonDialogTitle: "",
      commonRemarkDialog: false, //标记公共dialog框
      commonDialogForm: {
        remark: ""
      },
      currentUri: "" //批量操作api
    };
  },
  created() {
    this.orderCode = this.$route.query.orderCode;
  },
  components: {
    headerNotice
  },
  mounted() {
    this.getDatas();
  },
  methods: {
    //获取数据
    getDatas() {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminOrder/GetOrderDetails",
        params: {
          orderCode: this.orderCode
        },
        success(res) {
          self.orderItems = res;
          if (res.orderStatus.length) {
            res.orderStatus.forEach((ele, index) => {
              let arr = self.stepsstatus.filter(function(v) {
                return v == ele.status;
              });
              if (arr.length == 0) {
                self.stepsstatus.push(ele.status);
                self.steps.push(ele.logTime);
                console.log(self.steps);
              }
            });
          }
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    //确认审核订单a
    auditOrderConfirm() {
      let self = this;
      if (!this.auditForm.audit) {
        this.$message.error("请将滑块移到审核状态！");
        return;
      }
      if (!this.auditForm.remark) {
        this.$message.error("请填写备注");
        return;
      }
      this.setVerifyDialog = false;
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminOrder/AuditOrderVol",
        data: {
          orderID: [this.orderItems.orderID],
          audit: this.auditForm.audit,
          remark: this.auditForm.remark
        },
        success(res) {
          self.$message({
            type: "success",
            message: `已审核！`
          });
          self.getDatas();
          self.$forceUpdate();
        },
        fail(res) {}
      });
    },
    //转正常
    changeToNormal(orderID) {
      this.commonDialogTitle = "批量转正常";
      this.currentUri = "ReAuditOrderVol";
      this.commonRemarkDialog = true;
    },
    //关闭订单
    closeOrder(orderID) {
      this.commonDialogTitle = "关闭订单";
      this.currentUri = "CloseOrderVol";
      this.commonRemarkDialog = true;
    },
    //标记异常
    markupException() {
      this.commonDialogTitle = "标记异常";
      this.currentUri = "AuditFailOrderVol";
      this.commonRemarkDialog = true;
    },
    //备注订单
    remarkOrder(orderID) {
      this.commonDialogTitle = "备注订单";
      this.currentUri = "RemarkOrderVol";
      this.commonRemarkDialog = true;
    },
    //删除订单
    delOrder() {
      let self = this;
      this.$confirm("此操作将永久删除该条订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $http.POST({
            url:
              this.$store.state.apiUrl +
              "/api/services/app/AdminOrder/DelOrderVol",
            data: {
              orderID: [this.orderItems.orderID]
            },
            success(res) {
              self.$message({
                type: "success",
                message: `删除成功！`
              });
              self.$router.back();
              self.loading = false;
            },
            fail(res) {
              self.loading = false;
            }
          });
        })
        .catch(() => {});
    },
    //批量填写备注dialog框
    commonDialogConfirm() {
      let self = this;
      if (!this.commonDialogForm.remark) {
        this.$message.error("请填写备注");
        return;
      }
      this.commonRemarkDialog = false;
      let url =
        this.$store.state.apiUrl +
        "/api/services/app/AdminOrder/" +
        this.currentUri;
      $http.POST({
        url: url,
        data: {
          orderID: [this.orderItems.orderID],
          remark: this.commonDialogForm.remark
        },
        success(res) {
          self.$message({
            type: "success",
            message: `操作成功！`
          });
          self.getDatas();
          self.$forceUpdate();
        },
        fail(res) {}
      });
    },
    //订单跟踪
    orderFollow(orderID) {
      this.$router.push({
        path: "/logisticsInfo?orderCode=" + this.orderCode
      });
    },
    //取消按钮
    cancelBtn() {
      this.setVerifyDialog = false;
      this.commonRemarkDialog = false;
    },
    back() {
      this.$router.back();
    },
    //展示成功进度条
    showsuccess() {
      if (this.orderItems.orderCustomisationList.length > 0) {
        //定制
        if (this.steps.length == 5) {
          return this.steps.length+1;
        }
      } else {
        if (this.steps.length == 4) {
          return this.steps.length+1;
        }
      }
      return this.steps.length;
    }
  }
};
</script>

<style lang='scss' scoped>
// 右上角返回
.btn-wrapper {
  position: fixed;
  top: 80px;
  right: 60px;
  z-index: 100;
}
// 订单进度条
.orderStep {
  width: 70%;
  margin: 40px auto;
}
//订单信息
.orderInfoBox {
  margin: 0 50px;
  border: 1px solid #c5c5c5;
  background: #fff;
  // 订单状态 及操作
  .handle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 30px;
    background-color: #f3f3f3;
    border-bottom: 1px solid #c5c5c5;
    .orderStatus {
      color: #f63b3b;
      span {
        margin-left: 5px;
      }
    }
  }
  .infoBox {
    padding: 10px 30px;
    //通用css
    .title {
      padding-top: 25px;
      padding-bottom: 15px;
      span {
        margin-left: 5px;
      }
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      border: 1px solid #c5c5c5;
      li {
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        h3 {
          width: 100%;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f9fafc;
          border-bottom: 1px solid #c5c5c5;
        }
        .content {
          color: #666;
          font-size: 14px;
          min-height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          padding: 0 10px;
          &.red {
            color: #f63b3b;
          }
        }
      }
    }
    //基本信息
    .baseInfoBox {
      ul li {
        width: 20%;
        border-right: 1px solid #c5c5c5;
        &:nth-child(5),
        &:nth-child(10) {
          border-right: none;
        }
        &:nth-child(1),
        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(4),
        &:nth-child(5) {
          border-bottom: 1px solid #c5c5c5;
        }
      }
    }
    //发票信息 收货信息 费用信息
    .invoiceBox,
    .receiptBox,
    .tipsBox {
      ul li {
        flex: 1;
        border-right: 1px solid #c5c5c5;
        &:nth-last-child(1) {
          border-right: none;
        }
      }
    }
    //商品信息 赠品信息
    .goodsInfoBox,
    .giftBox {
      .goodsTable {
        border: 1px solid #c5c5c5;
        & /deep/ thead tr th {
          background: #f9fafc;
        }
        /deep/ &.el-table--border,
        /deep/ &.el-table--group,
        /deep/.el-table td,
        /deep/.el-table th.is-leaf {
          border-color: #c5c5c5 !important;
        }
        /deep/ tbody {
          border-bottom: 1px solid #c5c5c5;
        }
        .specAndCode {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: top;
          span {
            text-align: left;
          }
        }
      }
      .sum {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        background: #f9fafc;
        height: 60px;
        border: 1px solid #c5c5c5;
        border-top: none;
        padding-right: 30px;
      }
    }
    .shangerji {
      margin-right: 20px;
    }
  }
}
</style>